import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { Trash2, Plus, Minus } from "lucide-react";

export default function Cart() {
  const { items, updateQty, remove, totals } = useCart();

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
      <div className="eyebrow">Bag</div>
      <h1 className="mt-3 font-display text-5xl text-ink-900">Your bag, curated.</h1>

      {items.length === 0 ? (
        <div className="mt-16 border hairline p-16 text-center">
          <div className="font-display text-3xl">Your bag is empty.</div>
          <p className="mt-2 text-ink-500 text-sm">Start with a shield or a serum.</p>
          <Link to="/shop" className="mt-6 inline-block btn-primary-ink px-8 py-3 text-xs uppercase tracking-widest">Shop the collection</Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            {items.map((it) => (
              <div key={it.key} className="flex gap-6 py-6 border-b hairline" data-testid={`cart-row-${it.slug}`}>
                <img src={it.image} alt={it.name} className="w-24 h-32 object-cover bg-cream-200" />
                <div className="flex-1">
                  <div className="font-display text-xl text-ink-900">{it.name}</div>
                  {it.subscription && <div className="eyebrow text-gold-500 mt-1">Subscription · {it.subscription}</div>}
                  <div className="mt-3 flex items-center gap-3">
                    <button onClick={() => updateQty(it.key, it.quantity - 1)} className="w-8 h-8 border hairline flex items-center justify-center"><Minus size={12} /></button>
                    <span className="text-sm tabular-nums w-8 text-center">{it.quantity}</span>
                    <button onClick={() => updateQty(it.key, it.quantity + 1)} className="w-8 h-8 border hairline flex items-center justify-center"><Plus size={12} /></button>
                    <button onClick={() => remove(it.key)} className="ml-4 text-ink-500 hover:text-ink-900" aria-label="Remove"><Trash2 size={16} /></button>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-display text-lg">₹{(it.price * it.quantity).toFixed(0)}</div>
                  <div className="text-xs text-ink-500">₹{it.price.toFixed(0)} each</div>
                </div>
              </div>
            ))}
          </div>
          <div className="lg:col-span-4">
            <div className="border hairline p-8 sticky top-28">
              <div className="eyebrow">Summary</div>
              <div className="mt-6 flex justify-between text-sm"><span>Subtotal</span><span className="tabular-nums">₹{totals.subtotal.toFixed(0)}</span></div>
              <div className="mt-2 flex justify-between text-sm"><span>Shipping</span><span className="tabular-nums text-ink-500">calculated at checkout</span></div>
              <Link to="/checkout" className="mt-8 block text-center btn-primary-ink py-4 text-xs uppercase tracking-[0.28em]" data-testid="cart-page-checkout">
                Continue to checkout →
              </Link>
              <div className="mt-4 text-[11px] text-ink-500 text-center">Coupon codes are applied on the next step.</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
